import { useOutletContext } from 'react-router-dom';

import { BoardLayoutStore } from './BoardLayoutStore';

/** Стор шапки доски для вкладок: BoardLayout передаёт его через Outlet */
export const useBoardLayout = () => useOutletContext<BoardLayoutStore>();
